export const agentLaunchCapabilities = [
  {
    title: "Start from a URL, screenshot, or Figma file",
    description:
      "Build advertorials, listicles, quizzes, gift guides, and long-form offers.",
  },
  {
    title: "Build a complete ecommerce store from zero.",
    description:
      "Point Replo at a URL, apply your brand, then edit every detail.",
  },
  {
    title: "Create products, checkout, and fulfillment.",
    description:
      "Connect Stripe checkout and send paid merch orders to Printful automatically.",
  },
  {
    title: "Keep every brand asset in one place.",
    description:
      "Upload and reuse logos, images, fonts, and other files across your site.",
  },
  {
    title: "Connect Shopify, Klaviyo, Figma, and more.",
    description:
      "Bring store, lifecycle, design, sales, and conversion data into one workspace.",
  },
  {
    title: "Read ad performance, accessibility, and product margins.",
    description:
      "Work from connected campaign data, site audits, and product pricing in the same workspace.",
  },
] as const;
